import { useQuery } from '@tanstack/react-query';
import { getCustomerSegmentOptions } from '../../lib/api/options';
import type { GetCustomerSegmentOptionsParams } from '../../lib/api/options';

export function useCustomerSegmentOptions(
  params: GetCustomerSegmentOptionsParams = {},
  enabled = true,
) {
  return useQuery({
    queryKey: ['options', 'customer-segments', JSON.stringify(params)],
    queryFn: () => getCustomerSegmentOptions(params),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
